import React from "react";
import Layout from "components/layout";
import SEO from "components/seo";
import HeaderSeminar from "components/HeaderSeminar";
import SeminarCarouselSection from "components/SeminarCarouselSection";
import data from "fixtures/seminar.js";

export default function Seminar() {
  return (
    <Layout>
      <SEO title="Seminar" />
      <HeaderSeminar {...data.header} />
      <SeminarCarouselSection data={data.seminarAdvance} />
      <SeminarCarouselSection data={data.seminar} />
    </Layout>
  );
}
